import { HttpParams } from '@angular/common/http';

export function applyParams<T extends object>(params: T): HttpParams {
  let httpParams = new HttpParams();

  Object.keys(params).forEach((key) => {
    const param = params[key as keyof T];

    if (!param) {
      return;
    }

    if (Array.isArray(param)) {
      param.forEach((param: string | number | boolean) => (httpParams = httpParams.append(key, param)));
    } else {
      httpParams = httpParams.append(key, param as string | number | boolean);
    }
  });

  return httpParams;
}
